import React from 'react'
import { motion } from "framer-motion";
import { Users } from 'lucide-react';

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-background py-20">
      <div className="max-w-4xl mx-auto px-4">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-2xl shadow-xl overflow-hidden"
        >
          <div className="bg-primary p-10 text-center">
            <h1 className="text-3xl font-bold text-white mb-2">About The Project</h1>
            <p className="text-blue-100">Computer Science Thesis</p>
          </div>
          
          <div className="p-10 space-y-12">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                <Users className="text-secondary" /> The Researchers
              </h2>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="p-6 bg-gray-50 rounded-xl border border-gray-100">
                  <div className="h-16 w-16 bg-primary/10 rounded-full flex items-center justify-center text-primary font-bold text-xl mb-4">JG</div>
                  <h3 className="text-lg font-bold">Johnneri Garcia</h3>
                  <p className="text-sm text-gray-500">Researcher </p>
                </div>
                <div className="p-6 bg-gray-50 rounded-xl border border-gray-100">
                  <div className="h-16 w-16 bg-secondary/10 rounded-full flex items-center justify-center text-secondary font-bold text-xl mb-4">CK</div>
                  <h3 className="text-lg font-bold">Carl Trebor Katalbas</h3>
                  <p className="text-sm text-gray-500">Researcher </p>
                </div>
              </div>
            </section>

            {/* <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Project Adviser</h2>
              <div className="flex items-center gap-4 p-4 bg-blue-50 rounded-lg border border-blue-100">
                <div>
                  <h3 className="font-bold text-gray-900">Mr. Jaydee C. Ballaho, MIT</h3>
                  <p className="text-sm text-gray-600">Head, Department of Computer Science</p>
                </div>
              </div>
            </section> */}

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Institutional Context</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                This study, titled <em>"MALDROID: Malware Detection in Android Application through APK Analysis using Machine Learning Techniques"</em>, was presented to the Faculty of the Department of Computer Science, College of Computing Studies at Western Mindanao State University.
              </p>
              <p className="text-gray-600 leading-relaxed">
                The objective was to create an application-based system that integrates machine learning to reliably distinguish between benign and malicious applications.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default AboutUs